document.addEventListener('DOMContentLoaded', function() {
  // 1. Hantera "Läs mer" funktionen
  const readMoreContainers = document.querySelectorAll('.product__description.read-more');
  
  readMoreContainers.forEach(container => {
    const content = container.querySelector('.read-more__content');
    const btn = container.querySelector('.read-more__toggle');
    const lines = container.dataset.lines || 3;
    
    // Sätt clamp-klassen initialt
    content.classList.add('is-clamped');
    content.style.webkitLineClamp = lines; // För webkit
    
    btn.addEventListener('click', () => {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        // Stäng
        content.classList.add('is-clamped');
        content.style.webkitLineClamp = lines;
        btn.textContent = 'Läs mer';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        // Öppna
        content.classList.remove('is-clamped');
        content.style.webkitLineClamp = 'unset';
        btn.textContent = 'Visa mindre';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // 2. Hantera Drawer (Sidopanel)
  const drawers = document.querySelectorAll('.product-info-drawer');
  
  drawers.forEach(drawer => {
    const id = drawer.id;
    const triggers = document.querySelectorAll(`[data-target="#${id}"]`);
    const closeBtns = drawer.querySelectorAll('[data-close]');
    
    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden'; // Lås scroll på bakgrunden
    }
    
    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = ''; // Släpp scroll
    }
    
    triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer();
      });
    });
    
    closeBtns.forEach(btn => {
      btn.addEventListener('click', closeDrawer);
    });
    
    // Stäng på ESC-tangent
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });
  });
});